export default __webpack_public_path__ + "static/HOS_Logo_Condensed-c06d170544ba3dd497ea3934d5fdf9d6.png";